import React, { useEffect, useState } from 'react';
import earth from '../../images/earth-2.jpg';
import moon from '../../images/moon.jpg'
import mars from '../../images/mars.jpg';
import astro from '../../images/astro.jpg'
import Service from './Service/Service';
import Services from './Services/Services';
import Special from './Special/Special';

const Home = () => {

    return (
        <>
            <h1 className='text-success  mb-4 fw-bold pt-2'>Exoplanet Photography</h1>
{/* ------carousel------  */}
<div id="carouselExampleCaptions" className="carousel slide w-100" data-bs-ride="carousel">
  <div className="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 3"></button>
  </div>
  <div className="carousel-inner">
    
    <div className="carousel-item">
      <img src={mars} className="d-block img-fluid " alt="..."/>
      <div className="carousel-caption d-md-block">
        <h2>Mars's picture taken from the Earth</h2>
        <p>Mars is also known as the Red Planet.
Mars is named after the Roman god of war.
Mars has 2 moons called Deimos and Phobos.
It is the 4th planet from the sun and is smaller than Earth with a diameter of 4217 miles.</p>
      </div>
    </div>
    <div className="carousel-item active">
      <img src={earth} className="d-block img-fluid" alt="..."/>
      <div className="carousel-caption text-dark d-md-block">
        <h2>Pictures of the Earth taken from the sattelite</h2>
        <p> Earth is a terrestrial planet.
It’s also known as a telluric or rocky planet. A terrestrial planet simply refers to a planet that’s mostly composed of silicate rocks or metals. Other terrestrial planets in the Solar System include Mercury, Venus, and Mars.</p>
      </div>
    </div>
    <div className="carousel-item">
      <img src={moon} className="d-block img-fluid" alt="..."/>
      <div className="carousel-caption d-md-block">
        <h2> The Moon telescope picture</h2>
        <p>The Moon is drifting away from the Earth.
The Moon was made when a rock smashed into Earth.
The Moon makes the Earth move as well as the tides.
The Moon has quakes too.
There is water on the Moon!</p>
      </div>
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>          
<Service></Service>
<Special></Special>

</>

      
    );
};

export default Home;